import { getScreenshotLink } from '@/api/methods/computers';
import i18n from '@/api/i18n/i18n';

export function getScreenshotUrl(filepath) {
  return getScreenshotLink(this.$route.params.computer, filepath);
}

export function validateEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email) || email === '';
}

export function getTypePrint(outside) {
  if (outside === 1) {
    return i18n.t('global.duplex');
  } if (outside === 0 || outside === 2) {
    return i18n.t('global.simplex');
  }
  return '-';
}

export function getColored(colored) {
  if (colored === 1) {
    return i18n.t('global.color');
  } if (colored === 0 || colored === 2) {
    return i18n.t('global.blackAndWhite');
  }
  return '-';
}
